import fetch from '@/plugin/axios'

// 添加商品
export function addGoods (data) {
  return fetch({
    url: '/api/order/ar-msg-goods/add',
    method: 'Post',
    data: data
  })
}

// 商品列表
export function getGoodsList (query) {
  return fetch({
    url: '/api/order/ar-msg-goods/list',
    method: 'Post',
    data: query
  })
}

// 修改商品
export function editGoods (id, data) {
  return fetch({
    url: '/api/order/ar-msg-goods/update/' + id,
    method: 'Post',
    data: data
  })
}

// 删除商品
export function deleteGoods (id) {
  return fetch({
    url: '/api/order/ar-msg-goods/' + id,
    method: 'Delete'
  })
}

// 商品详情
export function getGoodsDetail (id) {
  return fetch({
    url: '/api/order/ar-msg-goods/info/' + id,
    method: 'Get'
  })
}

// 订单列表
export function getOrderList (query) {
  return fetch({
    url: '/api/order/ar-msg-order/list',
    method: 'Post',
    data: query
  })
}

// 订单详情
export function getOrderDetail (id) {
  return fetch({
    url: '/api/order/ar-msg-order/info/' + id,
    method: 'Get'
  })
}

// 添加订单
export function addOrder (data) {
  return fetch({
    url: '/api/order/ar-msg-order/add',
    method: 'Post',
    data: data
  })
}

// 删除订单
export function deleteOrder (id) {
  return fetch({
    url: '/api/order/ar-msg-order/' + id,
    method: 'Delete'
  })
}

// 修改订单
export function updateOrder (id, data) {
  return fetch({
    url: '/api/order/ar-msg-order/update/' + id,
    method: 'Post',
    data: data
  })
}

// 提交订单
export function submitOrder (id, data) {
  return fetch({
    url: '/api/order/ar-msg-order/commit/' + id,
    method: 'Post',
    data: data
  })
}
